
//
const insuredServiceButtons = document.querySelectorAll('.service-button[data-service="tds-insured-personal"], .service-button[data-service="tds-insured-company"]');

//
if (insuredServiceButtons !== undefined && insuredServiceButtons.length > 0) {

    //
    const zenoFetch = require('../utils/zenoFetch.js');

    //
    for (const insuredServiceButton of insuredServiceButtons) {

        //if this is the first time using the service, you must agree that you are using the service for your own properties
        if (insuredServiceButton.querySelector('input[name="agree-manage-only-own-properties"]') !== null) {
            insuredServiceButton.querySelector('input[name="agree-manage-only-own-properties"]').addEventListener('change', function(event) {
                insuredServiceButton.querySelector('button[data-action="manage-deposits"]').disabled = !event.target.checked;
            });
        }

        //toggle the information panel as needed
        insuredServiceButton.querySelectorAll('[data-action="toggle-service-information"]').forEach((toggleButton) => {
            toggleButton.addEventListener('click', function(event) {
                insuredServiceButton.setAttribute('data-show-service-information', ((insuredServiceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
            });
        });

        //
        insuredServiceButton.querySelector('button[data-action="manage-deposits"]')?.addEventListener('click', async function(event) {

            //
            if (event.target.disabled == true) {
                return false;
            }

            //
            event.preventDefault(); event.stopPropagation();

            //
            event.target.disabled = true;

            //
            const [status, response] = await zenoFetch('post', '/api/submit-tenancy-deposit-scheme-insured', null, {
                'type' : ((insuredServiceButton.dataset.service == 'tds-insured-personal') ? 'personal' : 'company'),
            });

            //
            if (status == 'success') {
                const serviceButtonForm = insuredServiceButton.querySelector('.service-button-button');
                serviceButtonForm.submit();
            }

        });

    }

}